import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Paper, Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    explanation: {
        marginTop: '1rem',
        padding: '.5rem',
        backgroundColor: '#88ba60',
        borderRadius: '20px'
    },
    image: {
//width: '50px',
        height: '50px',
    },
    item: {
        color: '#fff',
        fontSize: '20px'
    },
    icon: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '5px',
        border: '2px solid #fff',
        fontSize: '1.3em',
        fontWeight: 'bold'
    }
}));

// フローアイテム
function FlowItem(props){
    const classes = useStyles();

    const lines =  props.contents.split('<br>').map(function(line, index) {
        return (<div key={index}>{line}</div>);
    });

    return(
        <Paper className={classes.explanation}>
            <Grid container>
                <Grid item xs={2}>
                    <img src={props.image} className={classes.image}/>
                </Grid>
                <Grid item xs={10}>
                    <Box className={classes.item}>{lines}</Box>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default FlowItem
